angular.
module("dx.webapp.api").
factory("dxApiV1Skolon", function apiV1SkolonService(
	$http
) {
	"use strict";

	function authenticate(code, state) {
		return $http.get("/api/v1/skolon/authenticate?code=" + code + "&state=" + state);
	}

	return {
		authenticate: authenticate,
	};
});
